import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-upload-background',
  templateUrl: './modal-upload-background.component.html',
  styleUrls: ['./modal-upload-background.component.scss']
})
export class ModalUploadBackgroundComponent implements OnInit {

  uploadEvent:Event;

  constructor(public dialogRef: MatDialogRef<ModalUploadBackgroundComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  /**
   * Change local data
   * @param data New data
   */
  onChange(data){

    this.data.inputData = data;

  //  console.log(data);
  }

  /**
   * Close modal and return data
   * */
  onImport(){
    this.dialogRef.close(this.data.inputData);
  }


  /**
   * Close modal
   * @param data 
   */
  onNoClick(data): void {

    // this.data.inputData = data;

    this.dialogRef.close();
  }
}
